export default (): boolean => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};
